<template>
  <section
    id="banner"
    class="prescreenBanner"
  >
    <div
      class="inner atlas-banner"
    >
      <h3>We've matched you to your pre-approved offer up to ${{ maxLoanAmount }}!</h3>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    prospect: {
      type: Object,
    },
  },

  computed: {
    maxLoanAmount() {
      return (this.prospect?.campaign) ? this.prospect.campaign.maxLoanAmount : "X,XXX";
    },
  }
};
</script>

<style scoped>
.prescreenBanner {
  background: #5AAB5A;
}

.prescreenBanner h3 {
  color: #FFFFFF !important;
  font-size: 16px;
}
</style>
